// console.log( "test sub" )
// console.log( "ROLE", localStorage.getItem( 'UserInfo' ) )
let Routes = [
  {
    component: 'CNavItem',
    name: 'My Request',
    to: '/list-of-rfps/request-list',
    icon: 'cil-home',
  },
  {
    component: 'CNavItem',
    name: 'Approver view',
    to: '/list-of-rfps/approver-list',
    icon: 'cil-list',
  },
]
const userInf = JSON.parse( localStorage.getItem( 'UserInfo' ) )
if ( userInf && userInf.UserIsAnApprover == false )
{
  // console.log( 'ROLE =>', userInf.UserIsAnApprover )
  Routes = [ {
    component: 'CNavItem',
    name: 'My Request',
    to: '/list-of-rfps/request-list',
    icon: 'cil-home',
  }, ]

}


export default [
  //------------------------------------------
  ...Routes
]
